import { Component, Input } from '@angular/core';

import {
  CalendarEventResponseCoreFragment,
  EntityConnectionWithTagsFragment, EntityWithTagsFragment, TagGroupInfoFragment
} from 'generated/graphql';

@Component({
  selector: 'app-applied-tag-group-table',
  templateUrl: './applied-tag-group-table.component.html',
  styleUrls: ['./applied-tag-group-table.component.scss']
})
export class AppliedTagGroupTableComponent  {
  @Input() group: TagGroupInfoFragment;

  @Input() target: EntityWithTagsFragment | EntityConnectionWithTagsFragment | CalendarEventResponseCoreFragment;

  @Input() campaignId: string;

  constructor() { }


}
